import { FC, ReactElement, useState, useEffect } from 'react';
import styled from 'styled-components';
import { useHistory, useLocation } from 'react-router-dom';
import { LangeComponents, Dialog } from '@/components';
import { useTranslation } from 'react-i18next';
import { useLogin, useShowVote, useAddShowVote, useLanguage } from '@/state/base/hooks';
import { useMyVoteInfo } from '@/state/vote/hooks';
import VoteModal from '../voteModal';
import AddVoteModal from '../addVoteModal';
// import { message } from 'antd';


const Layout: FC = ({ children }): ReactElement => {
    const { t, i18n } = useTranslation();
    const history = useHistory();
    const { pathname } = useLocation();
    const [myVoteInfo, getMyVoteInfo] = useMyVoteInfo();
    const [showVote, handShowVote] = useShowVote();
    const [showAddVote, handAddShowVote] = useAddShowVote();
    const [language] = useLanguage();
    const [userInfo, login] = useLogin();
    const [showLange, setShowLange] = useState(false);
    const [open, setOpen] = useState(false);
    const [title, setTitle] = useState({
        '/vote-list': t('base.super rpc'),
        '/home': t('base.super rpc apply'),
        '/vote': t('base.my vote'),
        '/rpc-vote': t('base.super rpc'),
        '/governance': t('base.Governance'),
        '/backup-node': t('base.Backup node'),
    });
    const addVote = () => {
        //
        // if(process.env.REACT_APP_NET === 'production'){
        //     message.warning(t('base.Non-voting time'));
        //     return;
        // }

        if (myVoteInfo.votes === '--') return;
        if (myVoteInfo.votes > 0 && !!myVoteInfo.lastUnvotedTime) {
            setOpen(true);
        } else {
            handShowVote(true);
        }
    };

    useEffect(() => {
        setTitle({
            '/vote-list': t('base.super rpc'),
            '/home': t('base.super rpc apply'),
            '/vote': t('base.my vote'),
            '/rpc-vote': t('base.super rpc'),
            '/governance': t('base.Governance'),
            '/backup-node': t('base.Backup node'),
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n.language]);

    useEffect(() => {
        if (userInfo.name) {
            getMyVoteInfo();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userInfo.name]);

    return (
        <>
            <Main>
                <TopBar>
                    <Title>
                        <LabelLogo>
                            <img src="/images/logo.svg" alt="" />
                            {title[pathname]}
                        </LabelLogo>

                        <Menu>
                            <Lib className={pathname === '/vote-list' ? 'active' : ''} onClick={() => history.push('/vote-list')}>
                                {t('base.election list')}
                            </Lib>
                            <Lib className={pathname === '/vote' ? 'active' : ''} onClick={() => history.push('/vote')}>
                                {t('base.my vote')}
                            </Lib>
                            <Lib className={pathname === '/governance' ? 'active' : ''} onClick={() => history.push('/governance')}>
                                {t('base.Governance')}
                            </Lib>
                            <Lib className={pathname === '/backup-node' ? 'active' : ''} onClick={() => history.push('/backup-node')}>
                                备用节点
                            </Lib>
                        </Menu>
                    </Title>
                    <Right>
                        <Report src={language !== 'en_US' ? '/images/report.png' : '/images/report_en.png'} onClick={() => history.push('/report')} />
                        {pathname !== '/rpc-vote' && myVoteInfo.votes !== '--' &&  (
                            <SendVote className={myVoteInfo.votes > 0 && !!myVoteInfo.lastUnvotedTime ? 'disable' : ''} onClick={() => addVote()}>
                                {/* <SendVote className='disable' onClick={() => addVote()}> */}
                           {t('base.vote')}
                            </SendVote>
                        )}

                        <Wallet onClick={() => !userInfo.name && login()}>
                            <img src="/images/wallet.svg" alt="" />
                            {userInfo.name ? userInfo.name : t('base.connect wallet')}
                        </Wallet>

                        <LangeIcon src="/images/lange.svg" alt="" onClick={() => setShowLange(!showLange)} />
                        {showLange && <LangeComponents onClose={() => setShowLange(false)} />}
                    </Right>
                </TopBar>
                <Content>
                    <Children>{children}</Children>
                    {pathname !== '/rpc-vote' && (
                        <Tabs>
                            <TabCont>
                                <Itme className={pathname === '/vote-list' ? 'active' : ''} onClick={() => history.push('/vote-list')}>
                                    <Icon src={`/images/base/${pathname === '/vote-list' ? 'list-active' : 'list'}.svg`} />
                                    <Name>{t('base.election list')}</Name>
                                </Itme>
                                <Itme onClick={() => {
                                        addVote();
                                    }}>
                                    <Icon src={`/images/base/vote.svg`} />
                                    <Name>{t('base.vote')}</Name>
                                </Itme>
                                <Itme className={pathname === '/backup-node' ? 'active' : ''} onClick={() => history.push('/backup-node')}>
                                    <Icon src={`/images/base/${pathname === '/backup-node' ? 'backup-node-active' : 'backup-node'}.svg`} />
                                    <Name>{t('base.Backup node')}</Name>
                                </Itme>
                                <Itme className={pathname === '/governance' ? 'active' : ''} onClick={() => history.push('/governance')}>
                                    <Icon src={`/images/base/${pathname === '/governance' ? 'governance-active' : 'governance'}.svg`} />
                                    <Name>{t('base.Governance')}</Name>
                                </Itme>
                                {/* <Vote
                                    onClick={() => {
                                        addVote();
                                    }}
                                >
                                    {myVoteInfo.votes !== '--' && <VoteIcon className={myVoteInfo.votes > 0 && !!myVoteInfo.lastUnvotedTime ? 'disable' : ''}>{t('base.vote')}</VoteIcon>}
                                </Vote> */}
                                <Itme className={pathname === '/vote' ? 'active' : ''} onClick={() => history.push('/vote')}>
                                    <Icon src={`/images/base/${pathname === '/vote' ? 'my-active' : 'my'}.svg`} />
                                    <Name>{t('base.my vote')}</Name>
                                </Itme>
                            </TabCont>
                        </Tabs>
                    )}
                </Content>
            </Main>
            {open && <Dialog close={() => setOpen(false)} />}
            {showVote && <VoteModal />}
            {showAddVote && <AddVoteModal />}
        </>
    );
};
export default Layout;

const Main = styled.div`
    width: 100%;
    height: 100%;
    padding: 0.56rem 0 0;
    background-image: url('/images/bg.png');
    background-size: 100% auto;
    background-repeat: no-repeat;
    /* background-color: #f9fbfc; */
    background-color: #F9FBFC;
    @media screen and (min-width: 450px) {
        background: none;
    }
`;

const TopBar = styled.div`
    width: 100%;
    height: 0.44rem;
    line-height: 0.44rem;
    background: none;
    padding: 0 0.12rem;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    display: flex;
    align-items: center;
    justify-content: space-between;
    @media screen and (min-width: 450px) {
        width: 12rem;
        left: 50%;
        transform: translateX(-50%);
    }
`;
const LabelLogo = styled.div`
    text-align: left;
    color: #222;
    font-size: .16rem;
    @media screen and (min-width: 450px) {
        width: 2.4rem;
    }
`;
const Title = styled.div`
    height: 100%;
    font-family: 'Alibaba PuHuiTi 2.0';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    text-align: center;
    color: #222222;
    display: flex;
    align-items: center;
    img {
        width: 0.24rem;
        margin-right: 0.12rem;
    }
    i {
        margin-right: 0.06rem;
        display: inline-block;
        transform: rotate(180deg);
    }
`;
const Menu = styled.div`
    display: none;
    @media screen and (min-width: 450px) {
        display: flex;
    }
`;
const Lib = styled.div`
    height: 0.22rem;
    font-family: 'Alibaba PuHuiTi 2.0';
    font-style: normal;
    font-weight: 400;
    font-size: 0.16rem;
    line-height: 0.22rem;
    text-align: center;
    color: #cccccc;
    margin-right: 0.4rem;
    position: relative;
    cursor: pointer;
    &.active {
        font-weight: 600;
        color: #21212f;
        &::after {
            content: '';
            position: absolute;
            width: 70%;
            height: 0.02rem;
            background: #3555ff;
            border-radius: 0.02rem;
            bottom: -0.02rem;
            left: 50%;
            transform: translateX(-50%);
        }
    }
`;
const Right = styled.div`
    display: flex;
    align-items: center;
`;
const Report = styled.img`
    /* width: 0.24rem; */
    height: 0.31rem;
    cursor: pointer;
    margin-right: 0.12rem;
    @media screen and (min-width: 450px) {
        margin-right: 0.24rem;
    }
`;
const SendVote = styled.div`
    padding: 0 0.5rem;
    margin-right: 0.24rem;
    height: 0.28rem;
    background: #21212f;
    border-radius: 0.08rem;
    font-family: 'Alibaba PuHuiTi 2.0';
    font-style: normal;
    font-weight: 400;
    font-size: 0.12rem;
    line-height: 0.28rem;
    color: #ffffff;
    display: none;
    cursor: pointer;
    &.disable {
        background: rgba(33, 33, 47, 0.3);
    }
    @media screen and (min-width: 450px) {
        display: block;
    }
`;
const Wallet = styled.div`
    display: flex;
    align-items: center;
    font-family: 'Alibaba PuHuiTi 2.0';
    font-style: normal;
    font-weight: 400;
    font-size: 0.12rem;
    line-height: 0.17rem;
    color: #000000;
    padding: 0 0.08rem;
    min-width: 1.26rem;
    height: 0.28rem;
    border: 1px solid #000000;
    border-radius: 0.08rem;
    img {
        height: 0.17rem;
        margin-right: 0.04rem;
        margin-right: 0.19rem;
    }
`;

const LangeIcon = styled.img`
    cursor: pointer;
    height: 0.24rem;
    margin-left: 0.06rem;
`;

// const ConnectMain = styled.div`
//     padding: 0.4rem 0.28rem;
// `;
// const Section = styled.div`
//     width: 100%;
//     background: linear-gradient(359deg, #765bff 0%, #7663ff 100%);
//     border-radius: 0.08rem;
//     display: flex;
//     flex-direction: column;
//     align-items: center;
//     padding: 0.14rem 0 0.37rem;
// `;
// const Logo = styled.img`
//     width: 1.58rem;
// `;
// const LogoFont = styled.img`
//     margin: 0.2rem 0 0.08rem;
//     height: 0.4rem;
// `;
// const Label = styled.p`
//     height: 0.22rem;
//     font-size: 0.16rem;
//     font-family: PingFangSC-Regular, PingFang SC;
//     font-weight: 400;
//     color: #ffffff;
//     line-height: 0.22rem;
//     opacity: 0.6;
//     text-align: center;
// `;
// const Tip = styled.div`
//     height: 0.17rem;
//     font-size: 0.12rem;
//     font-family: PingFangTC-Regular, PingFangTC;
//     font-weight: 400;
//     color: #999999;
//     line-height: 0.17rem;
//     text-align: center;
//     margin: 0.36rem 0 0.12rem;
//     span {
//         font-weight: Bold;
//     }
// `;

// const Connect = styled(Button)`
//     height: 0.44rem;
//     width: 100%;
//     background: linear-gradient(358deg, #6a2dfe 0%, #705afe 100%);
//     box-shadow: 0px -1px 4px 0px rgba(0, 0, 0, 0.04);
//     border-radius: 0.64rem;
//     font-size: 0.16rem;
//     font-family: PingFangSC-Medium, PingFang SC;
//     font-weight: 500;
//     color: #ffffff;
//     line-height: 0.22rem;
//     text-shadow: 0px -1px 4px rgba(0, 0, 0, 0.04);
// `;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
`;
const Children = styled.div`
    flex: 1;
    overflow-y: hidden;
`;
const Tabs = styled.div`
    height: 0.48rem;
    position: relative;
    box-sizing: content-box;
    @media screen and (min-width: 450px) {
        display: none;
    }
`;
const TabCont = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    background: #fff;
`;
const Itme = styled.div`
    flex: 1.3;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    cursor: pointer;
    &.active div {
        color: #21212f;
    }
`;
const Icon = styled.img`
    width: 0.24rem;
    height: 0.24rem;
`;
const Name = styled.div`
    height: 0.15rem;
    font-family: 'Alibaba PuHuiTi 2.0';
    font-style: normal;
    font-weight: 400;
    font-size: 0.11rem;
    line-height: 0.15rem;
    color: #cccccc;
`;

const Vote = styled.div`
    flex: 1;
    display: flex;
    justify-content: center;
`;
const VoteIcon = styled.div`
    position: relative;
    width: 0.64rem;
    height: 0.64rem;
    line-height: 0.64rem;
    border-radius: 50%;
    background: #21212f;
    top: -0.3rem;
    font-family: 'Alibaba PuHuiTi 2.0';
    font-style: normal;
    font-weight: 400;
    font-size: 0.14rem;
    color: #ffffff;
    text-align: center;
    cursor: pointer;
    &.disable {
        background: rgba(33, 33, 47, 0.3);
    }
`;
